<template>
  <div>
    <el-page-header @back="goBack" content="测评结果设置"></el-page-header>
    <div class="topic-outer">
      <div class="appraisal-center fonts">
        <div class="pub-line">
          <span>分类：</span>
          <span class="glay"
          >{{ detalisObj.categoryName1 }}-{{ detalisObj.categoryName }}</span
          >
        </div>
        <div class="flex-box pub-line">
          <div class="fl1">
            <span>名称：</span>
            <span class="glay">{{ detalisObj.name }}</span>
          </div>
          <div class="fl1">
            <span> 标识：</span>
            <span class="glay">{{ detalisObj.examId }}</span>
          </div>
        </div>

        <div class="flex-box pub-line">
          <div class="fl1">
            <span>解析：</span>
            <span class="glay">{{ detalisObj.schemeName }}</span>
          </div>
          <div class="fl1">
            <span> 题目：</span>
            <span class="glay"
            >共 <i>{{ detalisObj.questions }}</i
            >题</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="topic-outer" v-if="jzIsShow">
      <div class="appraisal-center fonts marr">
        <div>
          第一次维护，需要初始化基准。该操作请在维度和基准维护完成后再操作！
          <div class="initialize">
            <el-button type="primary" plain @click="initJZ"
            >初始化基准
            </el-button
            >
          </div>
        </div>
      </div>
    </div>

    <div class="topic-outer" v-if="jzIsHiden" style="padding-bottom: 30px">
      <div class="appraisal-center fonts marr">
        <el-tabs
            tab-position="left"
            v-model="activeName"
            @tab-click="handleClick"
        >
          <el-tab-pane
              v-for="item in initJZData"
              :key="item.examResultId"
              :label="item.name"
              :name="item.examResultId.toString()"
          >
          </el-tab-pane>
          <div>
            <div class="public-dialog-form">
              <el-form
                  ref="ruleForm"
                  :rules="rules"
                  :model="params"
                  label-width="85px"
              >
                <el-row type="flex">
                  <el-col :span="14">
                    <el-form-item label="结果名称" prop="title">
                      <el-input v-model="params.title" style="width: 420px" placeholder="请输入名称"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item label="结果图">
                      <div class="diplay" style="margin-right: 10px">
                        <div class="screenshot">
                <span
                    v-for="(imgUrl, index) in srcList"
                    :key="index"
                    class="slideshow"
                >
                  <el-image
                      style="width: 135px; height: 135px;border-radius: 6px"
                      :src="imgUrl"
                      fit="cover"
                      @click="getPolicy"
                  />
                </span>
                          <div
                              class="up-btn"
                              style="width: 135px; height: 135px; line-height: 135px"
                              @click="getPolicy"
                              v-if="isMoer"
                          >
                            <i class="el-icon-plus"></i>
                          </div>
                        </div>
                        <input
                            type="file"
                            ref="file"
                            @change="getFile"
                            accept="image/png,image/jpg"
                        />
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-form-item label="结果说明" prop="suggest">
                  <rich-text v-if="innerVisible" :keyWord="'content'" :params="params?params:''"></rich-text>
                </el-form-item>

                <el-form-item label="结果解析" prop="guideSuggest">
                  <rich-text v-if="innerVisible" :keyWord="'suggest'" :params="params?params:''"></rich-text>
                </el-form-item>

                <el-form-item label="提升建议" prop="suggest2">
                  <rich-text v-if="innerVisible" :keyWord="'guideSuggest'" :params="params?params:''"></rich-text>
                </el-form-item>
              </el-form>
              <span slot="footer" class="public-dialog-footer">
                <el-button size="medium" @click="handleEdit('reset')"
                >重 置</el-button
                >
                <el-button
                    size="medium"
                    type="primary"
                    @click="handleEdit('add')"
                >提 交</el-button
                >
              </span>
            </div>
          </div>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import richText from "../../../components/richText";
import {ossUpload} from "@utils/filters/upload";
export default {
  components: {
    richText,
  },
  data() {
    return {
      rules: {
        title: [
          {
            required: true,
            message: "请填写结果名称",
            trigger: "blur",
          },
        ],
        content: [
          {
            required: true,
            message: "请填写结果说明",
            trigger: "blur",
          },
        ],

        suggest: [
          {
            required: true,
            message: "请填写结果解析",
            trigger: "blur",
          },
        ],
        guideSuggest: [
          {
            required: true,
            message: "请填写提升建议",
            trigger: "blur",
          },
        ],
      },
      detalisObj: {},
      loading: false,
      jzIsShow: true,
      jzIsHiden: false,
      initJZData: [],
      activeName: "",
      params: {},

      srcList: [],
      isMoer: true,
      innerVisible: false
    };
  },
  created() {
    this.getAppraisalData();
    this.initJZ();
  },
  methods: {
    getPolicy() {
      this.$refs.file.dispatchEvent(new MouseEvent("click"));
    },
    async getFile() {
      const that = this;
      const {data: resData} = await this.$get("aliyun/oss/sign", {
        headers: {
          isLoading: true,
        },
      });
      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
          that.$refs.file.files[0],
          resData.data,
          "one", //'more','one'
          this.srcList
      );
      this.isMoer = false;
      this.srcList = addRoutes;
      this.params.icon = this.srcList[0];
    },
    /**
     * 获取测评详情
     */
    async getAppraisalData() {
      this.loading = true;

      const {data: resData} = await this.$get(
          `exam/info/${this.$route.query.examId}`
      );
      this.loading = false;
      if (resData.result != 200) return;
      this.detalisObj = resData.data;
    },
    /**
     * 初始化基准
     */
    async initJZ() {
      this.loading = true;

      const {data: resData} = await this.$post(
          `exam/result/init/datum/${this.$route.query.examId}`
      );
      this.loading = false;
      if (resData.result != 200) return;
      if (resData.data) {
        this.jzIsShow = false;
        this.jzIsHiden = true;
      }
      resData.data.map(item => {
        item.examResultContent = item.name + '\n' + item.code
      })
      this.initJZData = resData.data;
      let id = resData.data[0].examResultId;
      this.activeName = id.toString();
      this.params.examResultId = id;
      this.resultDetails(id);
    },
    handleEdit(type) {
      if (type == "add") {
        this.$refs.ruleForm.validate((valid) => {
          if (!valid) return;
          this.$confirm("确认保存数据, 是否继续?", "提示", {
            type: "info",
          }).then(async () => {
            const {data: resData} = await this.$put(
                "exam/result/info",
                this.params,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );
            if (resData.result != 200) return;
            this.$message.success("提交成功!");
          })
        });
      } else if (type == "reset") {
        this.$confirm("确认重置当前数据, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          const {data: resData} = await this.$post(
              "exam/result/init/datum/" + this.$route.query.examId,
              {
                headers: {
                  isLoading: true,
                },
              }
          );
          this.$refs.ruleForm.resetFields();
          this.params = {}
          this.$message.success("重置成功!");
        })
      }
    },

    async resultDetails(examResultId) {
      const {data: resData} = await this.$get(
          `exam/result/info/${examResultId}`,
          {
            headers: {
              isLoading: true,
            },
          }
      );
      this.srcList = []
      this.isMoer = true
      if (resData.result != 200) return;
      this.params = resData.data;
      if (resData.data.icon) {
        this.srcList.push(resData.data.icon)
        this.isMoer = false
      }
      this.innerVisible = true
    },

    handleClick(tab, event) {
      this.innerVisible = false
      this.$refs.ruleForm.resetFields();
      this.params = {}
      this.params.examResultId = parseInt(tab.name);
      this.resultDetails(tab.name);
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.editor {
  line-height: normal !important;
  margin-bottom: 30px;
}

.initialize {
  margin-top: 20px;
}

.appraisal-title {
  color: #3a3a3a;
}

.appraisal-center {
  width: 90%;
  margin: 0 auto;
}

.fonts {
  font-size: 14px;
}

.topic-outer {
  width: 100%;
  background: #fff;
  overflow: hidden;
  margin-top: 20px;
  padding-bottom: 30px;
}

.flex-box {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}

.fl1 {
  flex: 1;
  -webkit-flex: 1;
}

.glay {
  color: #8492a6;

  i {
    font-style: normal;
    color: #f56c6c;
  }
}

.pub-line {
  margin-top: 30px;
}

.pub-marr {
  margin-top: 20px;
}

.marr {
  margin-top: 30px;
}

.tag-marr {
  margin-right: 5px;
  cursor: pointer;
}

.subject {
  color: #8492a6;
  margin-left: 10px;

  i {
    font-style: normal;
    color: #f56c6c;
  }
}

.activeBg {
  background: #b3d8ff;
  color: #fff;
}

.active-bg1 {
  background: #fbc4c4;
  color: #fff;
}

</style>
<style>
.topic-outer .el-tabs__item {
  white-space: pre-wrap;
  text-align: center !important;
  line-height: 20px;
  height: 36px !important;

}

.topic-outer .el-form-item {
  margin-bottom: 40px;
}

.topic-outer .ql-container.ql-snow {
  height: 260px;
}

.topic-outer .quill-editor.editor {
  margin-bottom: 0;
}
</style>